import React from 'react';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SampleError } from '@components/common/sampleError';
import { ErrorMessageContainer, ErrorCode } from './styles';

interface ErrorMessageViewProps {
  errorMessage: string;
  errorCode?: string;
}

const ErrorMessageView = ({ errorMessage, errorCode }: ErrorMessageViewProps) => (
  <ErrorMessageContainer>
    {errorCode && (
      <ErrorCode>
        <FontAwesomeIcon
          icon={solid('circle-xmark')}
          style={{ color: '#CA4139', fontSize: '1rem' }}
        />
        Error code {errorCode || ''}
      </ErrorCode>
    )}
    <SampleError sample={errorMessage} />
  </ErrorMessageContainer>
);

/* eslint-disable import/no-default-export */
export default ErrorMessageView;
